import { createFileRoute } from "@tanstack/react-router";
import { EkycCallbackPage } from "@/features/ekyc/EkycCallbackPage";

export const Route = createFileRoute("/ekyc/error/$clientId")({
  component: EkycErrorComponent,
});

function EkycErrorComponent() {
  const { clientId } = Route.useParams();
  return <EkycCallbackPage clientId={Number(clientId)} type="error" />;
}
